document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.attributeName === "open") {
        const modal = mutation.target;
        if (modal.hasAttribute("open")) {
          document.body.style.overflow = "hidden";
        } else {
          document.body.style.overflow = "";
        }
      }
    });
  });

  // Observe all modal-dialog elements with the class multicolumn-popup-modal
  document.querySelectorAll("modal-dialog.multicolumn-popup-modal").forEach((modal) => {
    observer.observe(modal, { attributes: true, attributeFilter: ["open"] });
  });
});
